import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';

export const RANK_MEDALS: Record<number, string> = {
  1: TipOne,
  2: TipTwo,
  3: TipThree,
};